// Updates hidden UL to select a matching set product variant for products with set_products on list-card-product.liquid snippet, to enable the OS default select option menu styling.

function pickerupdate(sel) {
  sel.closest('.list-card-product__controls').querySelector('.list-card-product__listbox [data-option="'+ sel[sel.selectedIndex].dataset.variant +'"]').click();
};